module.exports = __webpack_public_path__ + "img/main-collage.8609fb12.jpg";